import { useState, useEffect } from 'react';
import {
  List,
  Card,
  CardHeader,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  ListItemButton,
} from '@mui/material';
import SearchFilter from '../SearchFilter';
import { numberOfChecked } from './transfer-list-utils';

const TransferListItem = ({
  name,
  title,
  items,
  isLeft,
  checked,
  error,
  onToggleAll,
  onToggle,
  selectedLabelText,
  size,
  labelTextProp,
  disable,
}) => {
  const { height, width } = size || {};
  const cardBorderStyle = error ? 'red-border' : '';
  const numberOfItems = items?.length || 0;
  const listSideLabel = isLeft ? 'left' : 'right';
  const numberOfCheckedItems = numberOfChecked(items, checked);
  const [tempData, setTempData] = useState(null);
  const itemList = tempData || items;

  useEffect(() => {
    setTempData(null);
  }, [items, disable]);

  return (
    <Card className={cardBorderStyle}>
      <CardHeader
        sx={{ px: 1, py: 1 }}
        avatar={
          <Checkbox
            onClick={onToggleAll(items)}
            checked={
              numberOfCheckedItems === numberOfItems && numberOfItems !== 0
            }
            indeterminate={
              numberOfCheckedItems !== numberOfItems &&
              numberOfCheckedItems !== 0
            }
            disabled={numberOfItems === 0}
            inputProps={{
              'aria-label': 'all items selected',
            }}
          />
        }
        title={title}
        subheader={`${numberOfCheckedItems}/${numberOfItems} ${selectedLabelText}`}
      />
      <SearchFilter
        tableId={`${name}_${listSideLabel}_items`}
        list={items}
        setList={setTempData}
        isFilterBasicList
        targetProp={labelTextProp}
        resetSearch={disable}
      />
      <List
        sx={{
          width,
          height,
          bgcolor: 'background.paper',
          overflow: 'auto',
        }}
        dense
        component="div"
        role="list"
      >
        {itemList
          ?.filter((i) => !!i)
          ?.map((value) => {
            const labelId = `transfer-list-all-item-${value}-label`;
            const labelText = value?.[labelTextProp] || '';

            return (
              <ListItemButton
                key={`${name}_${listSideLabel}_${labelText}`}
                role="listitem"
                onClick={onToggle(value)}
                sx={{ px: 1 }}
              >
                <ListItemIcon>
                  <Checkbox
                    checked={checked.indexOf(value) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{
                      'aria-labelledby': labelId,
                    }}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={`${labelText}`} />
              </ListItemButton>
            );
          })}
        <ListItem />
      </List>
    </Card>
  );
};

export default TransferListItem;
